import {modalBus} from 'modals/modalBus';

export default {
  install (Vue) {
    Vue.mixin({
      created () {
        Vue.prototype.$openModal = (payload) => {


          modalBus.$emit('openModal', payload);
        };

        Vue.prototype.$closeModal = () => {
          modalBus.$emit('closeModal');
        };
      }
    });
  }
};
